import styled from 'styled-components';
import { Button } from '.';
import { colors } from '../../globalStyles';

export const Box = styled.div({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  borderRadius: '5px',
  padding: '0',
  color: colors.white,
  width: '80%',
  margin: '0px 20px',
  '@media only screen and (max-width: 944px)': {
    padding: '0',
    width: '100%',
  },
  backgroundColor: colors.green,
});

export const Header = styled.div({
  textAlign: 'center',
  borderRadius: '5px',
  color: colors.white,
  width: '100%',
  padding: '30px',
  backgroundColor: colors.darkGreen,
});

export const Title = styled.h2({
  fontSize: '30px',
  fontWeight: 500,
});

export const Info = styled.div({
  width: '100%',
  textAlign: 'right',
  marginTop: '-20px',
  marginLeft: '15px',
});

export const ExtraInfo = styled.div({
  marginTop: '10px',
});

export const ButtonCTA = styled(Button as any)((props: { gold?: boolean; }) => ({
  marginTop: '10px',
  marginBottom: '10px',
  border: 0,
  backgroundImage: props.gold ? 'linear-gradient(to bottom right, rgb(221,120,10), rgb(232,173,0))' : 'none',
}));
